<template>
  <router-view></router-view>
</template>

<script>

export default {
  created() {
    console.log("App created, session exists : " + this.$session.exists())

    if (!this.$session.exists()) {
      console.log("Creating session")

      this.$session.start()
    }

    if (!this.$session.has('organisatonId')) {
      this.$session.set('organisationId', '609baea94094aedf63052572') // TODO Testing
    }
  }
}
</script>
